














































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() recordId!: number;

  @Prop() stadiumId!: number;

  dispatchType = "invitecode/logs";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "邀请码", dataIndex: "invite_code" },
    { title: "发送时间", dataIndex: "created_time" },
    { title: "使用时间", scopedSlots: { customRender: "updated_time" } },
    { title: "发送客服", scopedSlots: { customRender: "user" } },
    { title: "状态", scopedSlots: { customRender: "verified" } }
  ];

  mounted() {
    this.loadData({
      record_id: this.recordId,
      stadium_id: this.stadiumId
    });
  }

  async sendInviteCode() {
    this.$confirm({
      title: "确认信息",
      content: "您确定要给这家场馆发送邀请码吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/sendinvitecode", {
          stadium_id: this.stadiumId
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }
}
